module.exports = __webpack_public_path__ + "img/sld_mccb.f9d8eebc.svg";